import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IQuestion } from '@interfaces/index';

@Component({
  selector: 'app-status-bar',
  templateUrl: './status-bar.component.html',
  styleUrl: './status-bar.component.scss'
})
export class StatusBarComponent {

  @Input() questions: IQuestion[] = [];
  @Input() total_answered: number = 0;
  @Output() onComplete: EventEmitter<void> = new EventEmitter();

  get totalQuestions(): number {
    return this.questions.length ?? 0;
  }

  get percentage(): number {
    if (this.total_answered == 0) {
      return 0
    }

    return (this.total_answered / this.totalQuestions) * 100
  }

  handleClick() {
    this.onComplete.emit();
  }

}
